// extracted by mini-css-extract-plugin
export default {"loader":"AIPilotSpinner_loader__TiKpQ"};